export function getLastUrlSegment(url: string): string {
  return url?.split('/').filter(Boolean).pop();
}
